/**
 * @generated SignedSource<<1a23e327ca6356ab8830642b87392f23>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HttpsConfigurationPageNodesQuery$variables = Record<PropertyKey, never>;
export type HttpsConfigurationPageNodesQuery$data = {
  readonly nodes: {
    readonly count: number | null | undefined;
  } | null | undefined;
};
export type HttpsConfigurationPageNodesQuery = {
  response: HttpsConfigurationPageNodesQuery$data;
  variables: HttpsConfigurationPageNodesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Nodes",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HttpsConfigurationPageNodesQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HttpsConfigurationPageNodesQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "e17a620c4957c17d3daacd344195824a",
    "id": null,
    "metadata": {},
    "name": "HttpsConfigurationPageNodesQuery",
    "operationKind": "query",
    "text": "query HttpsConfigurationPageNodesQuery {\n  nodes {\n    count\n  }\n}\n"
  }
};
})();

(node as any).hash = "423744b3d39e67ca44fdf583daf0bc20";

export default node;
